/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import './VisaListRecordCount.css'
import { object } from 'yup'



type Props = {
    className?: string
    heading?: string
    total_count?: string
    route_heading?: string
    data?: any
    name?: string
    count?: any
    emptycount?: any
    filter?: any
}

const VisaListDateRecord: React.FC<Props> = ({ className, heading, count, data, emptycount, filter, name }) => {
    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{heading}</h3>
            </div>

            <div className='card-body pt-4 custom-fixed-height'>
                <div >
                    {data?.map((obj: any, index: any) =>
                        <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                            <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                            <div className='row flex-grow-1 ' style={{ marginLeft: 4, marginRight: 4 }}>
                                {
                                    obj?.[`type`] === 'applicant' ? (
                                        name === "passport_exp" ? (<span className='col-1 fw-bold badge badge-info d-inline-block mb-1' style={{ fontSize: '12px', paddingRight: '14px' }}>{'A'}</span>)
                                            : (<span className='col-1 fw-bold badge badge-info d-inline-block mb-1' style={{ fontSize: '12px' }}>{'A'}</span>)
                                    ) : (
                                        obj?.[`type`] === 'spouse' ? (
                                            name === "passport_exp" ? (<span className='col-1 fw-bold badge badge-secondary d-inline-block mb-1' style={{ fontSize: '12px', paddingRight: '14px' }}>{'S'}</span>)
                                                : (<span className='col-1 fw-bold badge badge-secondary d-inline-block mb-1' style={{ fontSize: '12px' }}>{'S'}</span>)
                                        ) : (
                                            name === "passport_exp" ? (<span className='col-1 fw-bold badge badge-dark d-inline-block mb-1' style={{ fontSize: '12px', paddingRight: '14px' }}>{'C'}</span>)
                                                : (<span className='col-1 fw-bold badge badge-dark d-inline-block mb-1' style={{ fontSize: '12px' }}>{'C'}</span>)
                                        )
                                    )
                                }
                                {
                                    obj?.[`l_name`] ? (<>
                                        <div className='col-6 text-gray-800 text-hover-primary fw-bold fs-6' style={{ paddingLeft: 8, paddingRight: 3 }}>
                                            {obj?.[`name`]}
                                        </div>
                                        <span className='col-5 fw-bold badge badge-secondary d-block' style={{ fontSize: '12px' }}>{obj?.[`l_name`]}</span>
                                    </>
                                    ) : (<div className='col-10 text-gray-800 text-hover-primary fw-bold fs-6' style={{ paddingLeft: 3, paddingRight: 3 }}>
                                        {obj?.[`name`]}
                                    </div>)
                                }
                                {/* <div className='col-10 text-gray-800 text-hover-primary fw-bold fs-6' style={{paddingLeft:3, paddingRight:3}}>
                                    {obj?.[`name`]}
                                </div> */}
                                {/* <a href='#' className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                </a> */}
                            </div>
                            <div className=' fw-bold fs-5' style={{ color: 'red' }}>
                                {obj?.[`date`]}
                            </div>
                            <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/edit/${obj?.[`id`]}`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}
                                <span className={`svg-icon svg-icon-2`}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                        <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                    </svg>
                                </span>
                            </a>
                            {/* <span className='fw-bold badge badge-primary d-block me-2'>{obj?.[`date`]}</span> */}
                            {/* {
                                hasMatchingKey ?
                                    <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${newFilteredFilter}&${name}=${obj?.[`id`]}`} type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                        <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                    </a> :
                                    <a href={`${process.env.REACT_APP_HOME_PAGE}visafile-management/list?${filteredFilter}&${name}=${obj?.[`id`]}`} type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                                        <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' />
                                    </a>
                            } */}

                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}

export { VisaListDateRecord }
